import { StatusLabel } from '@/components/StatusLabel';

import { ADMIN_STATUS_OPTIONS } from '@/constants/adminStatus';

interface ClaimStatusDropdownProps {
  currentEffectiveKey: string;
  validTransitions: string[];
  onSelect: (optValue: string) => void;
}

export function ClaimStatusDropdown({
  currentEffectiveKey,
  validTransitions,
  onSelect,
}: ClaimStatusDropdownProps) {
  const options = ADMIN_STATUS_OPTIONS.filter(
    (opt) => opt.value !== currentEffectiveKey && validTransitions.includes(opt.value),
  );

  if (options.length === 0) {
    return (
      <div className="px-4 py-2.5 text-center text-sm text-gray-400">
        No status changes available
      </div>
    );
  }

  return (
    <div className="space-y-2 py-2">
      {options.map((opt) => (
        <button
          key={opt.value}
          data-testid="status-option"
          onClick={(e) => {
            e.stopPropagation();
            onSelect(opt.value);
          }}
          className="flex w-full cursor-pointer px-2 transition-opacity hover:opacity-80 focus:outline-hidden"
        >
          <StatusLabel
            status={
              opt.value === 'pending_yellow' || opt.value === 'pending_red' ? 'pending' : opt.value
            }
            flag={
              opt.value === 'pending_yellow' ? 'yellow' : opt.value === 'pending_red' ? 'red' : null
            }
            className="w-full"
          />
        </button>
      ))}
    </div>
  );
}
